import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CreateGame from "./pages/CreateGame";
import JoinGame from "./pages/JoinGame";
import PlayGame from "./pages/PlayGame";
import Win from "./pages/Win";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/create" element={<CreateGame />} />
        <Route path="/join" element={<JoinGame />} />
        <Route path="/play" element={<PlayGame />} />
        <Route path="/win" element={<Win />} />
      </Routes>
    </Router>
  );
};

export default App;
